import { useEffect } from 'react';

// На мобильных устройствах (<=1024px) переключает viewport между фиксированной
// шириной 1024 для страниц редактора и стандартным responsive-режимом для остальных.
export const useViewportMeta = (pathname: string) => {
  useEffect(() => {
    if (window.innerWidth > 1024) return;

    const viewportMeta = document.querySelector('meta[name="viewport"]');
    const isFixed = pathname.match(/\/create|files|\/workspace/);

    viewportMeta?.setAttribute(
      'content',
      isFixed ? 'width=1024' : 'width=device-width, initial-scale=1',
    );
  }, [pathname]);
};
